// Adapter para la API de tiendas
// Shops API adapter

import { apiClientWH } from '@shared/services/ApiClient';

export interface Shop {
  id: number;
  name: string;
  channel_id: number;
  status: number;
  connect_data: any;
  team_id: number;
  default_payment_method_id: number | null;
  fulfillment: any;
  approval_type: number;
  created_at: string;
  updated_at: string;
  linked_payment_methods: any[];
  image: string | null;
}

export interface ShopsResponse {
  data: Shop[];
  meta: {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
  };
  links: {
    first: string;
    prev: string | null;
    next: string | null;
    last: string;
  };
}

export class ShopsApiAdapter {
  constructor(private httpClient: typeof apiClientWH) {}

  async getShops(): Promise<ShopsResponse> {
    const response = await this.httpClient.get('/shops');
    return response.data;
  }
}
